'use client';

import { formatPercentage } from '@campaign-manager/core/lib/utils';
import { useLocalization } from '@campaign-manager/feature/context/Localization';

import Value from '../Value';

interface Props {
  value: number | null | undefined;
  locale?: string | null | undefined;
  placeholder?: string;
}

export default function PercentValue({ value, placeholder }: Props) {
  const { numberFormatLocale: locale } = useLocalization();
  return (
    <Value
      value={PercentString({ value, locale })}
      placeholder={placeholder}
    />
  );
}

export function PercentString({ value, locale }: Props) {
  return value ? formatPercentage(value, locale ?? undefined) : undefined;
}
